<template>
  <div class="wtv-stars">
    <div
      v-for="star in 5"
      :key="star"
      class="wtv-star wtv-icon"
      :class="{ 'wtv-star-unchecked': star > amount }"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import { useStore } from 'vuex';

export default defineComponent({
  props: {
    amount: Number,
  },
  setup() {
    return {};
  },
});
</script>

<style scoped>
  /* stars */
  .wtv-stars {
    display: flex;
    margin-right: 8px;
    margin-left: 8px;
  }
  .wtv-star,
  .wtv-star-unchecked {
    margin-right: 2px;
    cursor: pointer;
  }
  .wtv-star-unchecked:before,
  .wtv-star:before {
    content: '\f005';
    font-size: 14px;
  }
  .wtv-star:before {
    color: var(--color-third);
  }
  .wtv-star-unchecked:before {
    color: var(--color-alt-5);
  }
</style>
